import { useState } from 'react';
import { Check, X, ChevronDown, ChevronUp } from 'lucide-react';
import { FEATURE_COMPARISON } from '../data/pricingData';

// Expandable "Compare all features" matrix used on the plan-selection screen.
export const FeatureMatrix = () => {
  const [expanded, setExpanded] = useState(false);

  const renderCell = (value) => {
    if (value === true) {
      return <Check className="h-5 w-5 text-green-500 mx-auto" />;
    } else if (value === false) {
      return <X className="h-5 w-5 text-zinc-600 mx-auto" />;
    } else if (value === 'soon') {
      return <span className="text-xs text-amber-500 font-medium">Soon</span>;
    }
    return value;
  };

  return (
    <div className="mt-8">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-center gap-2 text-zinc-400 hover:text-white transition-colors py-3"
        data-testid="feature-comparison-toggle"
      >
        <span className="text-sm font-medium">Compare all features</span>
        {expanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>

      {expanded && (
        <div className="mt-4 bg-card rounded-lg border border-zinc-800 overflow-hidden" data-testid="feature-matrix">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-zinc-800 bg-zinc-900/50">
                  <th className="text-left py-4 px-4 font-medium text-zinc-400 w-1/3">Feature</th>
                  <th className="text-center py-4 px-4 font-medium text-zinc-400">Basic</th>
                  <th className="text-center py-4 px-4 font-medium text-[#ffd108]">Advanced</th>
                  <th className="text-center py-4 px-4 font-medium text-zinc-400">Professional</th>
                </tr>
              </thead>
              <tbody>
                {FEATURE_COMPARISON.map((category, catIdx) => (
                  <>
                    <tr key={`cat-${catIdx}`} className="bg-zinc-800/50">
                      <td colSpan={4} className="py-2 px-4 font-semibold text-white text-xs uppercase tracking-wider">
                        {category.category}
                      </td>
                    </tr>
                    {category.features.map((feature, featIdx) => (
                      <tr
                        key={`feat-${catIdx}-${featIdx}`}
                        className="border-b border-zinc-800/50 hover:bg-zinc-800/30 transition-colors"
                      >
                        <td className="py-3 px-4 text-zinc-300">{feature.name}</td>
                        <td className="py-3 px-4 text-center">{renderCell(feature.basic)}</td>
                        <td className="py-3 px-4 text-center bg-[#ffd108]/5">{renderCell(feature.advanced)}</td>
                        <td className="py-3 px-4 text-center">{renderCell(feature.professional)}</td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureMatrix;
